import { createFileRoute, redirect } from "@tanstack/react-router";
import { FormPageSkeleton } from "@/components/app/skeletons";
import { Callout } from "@/components/ui/callout";
import { useAuth } from "@/features/auth/store";
import { ArrivalPage } from "@/features/stores/components/arrival-page";
import { errMsg, useArrival } from "@/features/stores/hooks";

export const Route = createFileRoute("/_app/stores/arrivals/$id")({
  beforeLoad: () => {
    if (!useAuth.getState().can("stores.view")) throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const { id } = Route.useParams();
  const arrival = useArrival(Number(id));
  if (arrival.isPending) return <FormPageSkeleton />;
  if (arrival.isError)
    return (
      <Callout tone="danger" title="Could not open this arrival">
        {errMsg(arrival.error)}
      </Callout>
    );
  // Re-seeded whenever the status moves, so the header starts from what the server holds.
  return (
    <ArrivalPage
      key={`${arrival.data.id}-${arrival.data.status}`}
      arrival={arrival.data}
      kind={arrival.data.kind}
      facilityId={arrival.data.facilityId}
      plantName={arrival.data.facility?.name ?? null}
    />
  );
}
